export default class PropertyValueType
{
	static STRING = 0;
	static INT = 1;
	static BOOLEAN = 2;
	static PROPERTY_XML = 3;
}


// WEBPACK FOOTER //
// ./src/utils/PropertyValueType.js